/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpServiceProjects } from './http.service.project';

@Injectable()
export class ProjectsApi {
  private readonly apiController: string = 'project';

  constructor(private api: HttpServiceProjects) {}

  getAll(): Observable<any> {
    return this.api.get(`${this.apiController}/all`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        // return { ...data, picture };
        return { ...data };
      }));
  }

  get(id: number): Observable<any> {
    return this.api.get(`${this.apiController}/${id}`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        // return { ...data, picture };
        return { ...data };
      }));
  }

  updateCurrent(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/current`, item);
  }

  update(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/${item.id}`, item);
  }

  // delete(id: number): Observable<boolean> {
  //   return this.api.delete(`${this.apiController}/${id}`);
  // }

  // add(item: any): Observable<any> {
  //   return this.api.post(this.apiController, item);
  // }
}
